import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A5DerivativeUnderlyingsEdit } from "./edit";
import { A5DerivativeUnderlyingsNew } from "./new";
import { A5DerivativeUnderlyingsTable } from "./table";
export default function A5DerivativeUnderlyings() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Derivatives Underlyings");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A5DerivativeUnderlyingsEdit />} />
      <Route index element={<A5DerivativeUnderlyingsTable />} />
      <Route path="/new" element={<A5DerivativeUnderlyingsNew />} />
    </Routes>
  );
}
